"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadedGuarantee = exports.StructureContext = exports.StructureContextStates = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const assertHelpers_1 = require("./assertHelpers");
exports.StructureContextStates = Object.freeze({
    noGuarantees: Object.freeze({
        guaranteedLoaded: false,
    }),
    guaranteedLoaded: Object.freeze({
        guaranteedLoaded: true,
    }),
});
exports.StructureContext = react_1.default.createContext(undefined);
exports.StructureContext.displayName = 'StructureContext';
const useStructureContext = () => {
    const structureCtx = react_1.default.useContext(exports.StructureContext);
    (0, assertHelpers_1.assertWrappedByClerkProvider)(structureCtx);
    return structureCtx;
};
const LoadedGuarantee = ({ children }) => {
    const structure = useStructureContext();
    if (structure.guaranteedLoaded) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return (react_1.default.createElement(exports.StructureContext.Provider, { value: exports.StructureContextStates.guaranteedLoaded }, children));
};
exports.LoadedGuarantee = LoadedGuarantee;
//# sourceMappingURL=StructureContext.js.map